const numberFormat = new Intl.NumberFormat('en').format;

export default numberFormat;
